// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16Tg4","content":"styles_content__rmFN-","tableWrap":"styles_tableWrap__2QmdR"};